import { EmptyState, EmptyStateBody, PageSection, PageSectionVariants, Title } from '@patternfly/react-core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAppDeploymentInfo, selectClientList } from '../../store/selectors';

import logo70b from '../../img/mvision-title-black-70.png';
import { DeploymentMode } from '../../store/deployment-config-info';


const HomePage = () => {

    const { t } = useTranslation();
    const clientList = useSelector(selectClientList);
    const deploymentInfo = useSelector(getAppDeploymentInfo);

    return (
        <>
            <PageSection variant={PageSectionVariants.light}>
                <EmptyState>
                    {/* Weird bug in cockpit: returning to the home page will fail to load the logo image the second time! So don't show it in the first place. */}
                    {deploymentInfo && deploymentInfo.deploymentMode !== DeploymentMode.Local && (
                        <div className="logged-out-logo">
                            <img src={logo70b} alt="MVision logo" />
                        </div>
                    )}

                    <Title headingLevel="h4" size="lg">{t('homePage.title.long', { appName: t('appTitle') })}</Title>
                    {clientList && (<EmptyStateBody>{t(clientList.length > 1 ? 'homePage.body.multipleTargets' : 'homePage.body.oneTarget', { appName: t('appTitle') })}</EmptyStateBody>)}
                </EmptyState>
            </PageSection>
        </>
    );
}

export default HomePage;
